import React, { Component, forwardRef } from 'react';
class InlineDialog extends Component {
    constructor() {
        super(...arguments);
        this.handleClickOutside = (event) => {
            if (this.containerRef &&
                !this.containerRef.contains(event.target)) {
                this.props.onClose({ event });
            }
        };
        this._handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                this.props.onClose({ event });
            }
        };
        this._setContainerRef = (el) => {
            this.containerRef = el;
        };
        this._setTriggerRef = (el) => {
            this.triggerRef = el;
        };
    }
    componentDidMount() {
        if (this.props.isOpen) {
            this._addListeners();
        }
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this._addListeners();
        }
        else if (prevProps.isOpen && !this.props.isOpen) {
            this._removeListeners();
        }
    }
    componentWillUnmount() {
        this._removeListeners();
    }
    _addListeners() {
        document.addEventListener('mousedown', this.handleClickOutside, true);
        document.addEventListener('keydown', this._handleKeyDown, true);
    }
    _removeListeners() {
        document.removeEventListener('mousedown', this.handleClickOutside, true);
        document.removeEventListener('keydown', this._handleKeyDown, true);
    }
    _placementClass() {
        // collapse 'auto' variants to a sensible default; extend with
        // real collision detection later if you need dynamic flipping
        const fallback = {
            auto: 'bottom-start',
            'auto-start': 'bottom-start',
            'auto-end': 'bottom-end'
        };
        const placement = fallback[this.props.placement] || this.props.placement;
        return `inline-dialog--${placement}`;
    }
    render() {
        const { children, content, isOpen, onContentBlur, onContentClick, onContentFocus, testId } = this.props;
        return (React.createElement("div", { className: 'inline-dialog-wrapper', ref: this._setContainerRef, "data-testid": testId && `${testId}--wrapper` },
            React.createElement("div", { ref: this._setTriggerRef }, children),
            isOpen && (React.createElement("div", { className: `inline-dialog ${this._placementClass()}`, onBlur: onContentBlur, onClick: onContentClick, onFocus: onContentFocus, "data-testid": testId, tabIndex: -1 }, content))));
    }
}
InlineDialog.defaultProps = {
    isOpen: false,
    onContentBlur: () => { },
    onContentClick: () => { },
    onContentFocus: () => { },
    onClose: () => { },
    placement: 'bottom-start'
};
export { InlineDialog as InlineDialogWithoutAnalytics };
const ForwardedInlineDialog = forwardRef((props, ref) => (React.createElement(InlineDialog, Object.assign({}, props, { ref: ref }))));
export default ForwardedInlineDialog;
